import { render, staticRenderFns } from "./SwitchPlansLoaders.vue?vue&type=template&id=203ced59"
import script from "./SwitchPlansLoaders.vue?vue&type=script&lang=js"
export * from "./SwitchPlansLoaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports